import axios from 'axios';
import router from '../router/index'
import store from "../store";
import Vue from 'vue';
import { Loading, Alert } from 'element-ui'; //项目已经全局引入element的话可以不单独引入

//http://apk.neters.club

//调试接口
// var base ='http://192.168.11.73:5724/api';
// var socketBase='ws://192.168.11.73:4040/';
//正式接口
var base = 'https://zlgk.datascore.cn/api';
 var socketBase = 'ws://zlgk.datascore.cn:4040/';
//公共部分
var imgUrlBase = 'https://zlgk.datascore.cn';

 export const BaseApiUrl = base;
 export const baseSocketUrl = socketBase;
 export const imgUrl = imgUrlBase;


// 如果是IIS部署，用这个，因为 IIS 只能是 CORS 跨域，不能代理·
// let base = process.env.NODE_ENV=="production"? 'http://localhost:8081':'';
//身份证读卡机人员认证地址
// 请求延时
axios.defaults.timeout = 60000

var storeTemp = store;

//全局引用loading
let loading;
export function startLoading() {    //使用Element loading-start 方法
    loading = Loading.service({
        lock: true,
        text: '加载中……',
        background: 'rgba(0, 0, 0, 0.7)'
    })
}
export function endLoading() {    //使用Element loading-close 方法
    loading.close();
}
axios.interceptors.request.use(
    config => {
        var curTime = new Date()
        var expiretime = new Date(Date.parse(storeTemp.state.tokenExpire))

        if (storeTemp.state.token && (curTime < expiretime && storeTemp.state.tokenExpire)) {
            // 判断是否存在token，如果存在的话，则每个http header都加上token
            config.headers.Authorization = "Bearer " + storeTemp.state.token;
        }
        saveRefreshtime();
        // var date1=curTime;
        // if(window.localStorage.loadDate!=undefined)
        // {
        //     var date1= window.localStorage.loadDate
        //     if()
        // }
        // window.localStorage.loadDate=curTime;
        startLoading();
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);

// http response 拦截器
axios.interceptors.response.use(
    response => {
        endLoading();
        return response;
    },
    error => {
        // 超时请求处理
       
        var originalRequest = error.config;
       
        if (error.message === 'Network Error'||(error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1 && !originalRequest._retry)) {
           Vue.prototype.$message({
                message: '请求超时！',
                type: 'error'
            });
            endLoading();
            originalRequest._retry = true
            return null;
        }

        if (error.response) {
            if (error.response.status == 401) {
                var curTime = new Date()
                var refreshtime = new Date(Date.parse(window.localStorage.refreshtime))
                // 在用户操作的活跃期内
                if (window.localStorage.refreshtime && (curTime <= refreshtime)) {
                    return refreshToken({ token: window.localStorage.Token }).then((res) => {
                        if (res.success) {
                            Vue.prototype.$message({
                                message: 'refreshToken success! loading data...',
                                type: 'success'
                            });

                            store.commit("saveToken", res.response.token);

                            var curTime = new Date();
                            var expiredate = new Date(curTime.setSeconds(curTime.getSeconds() + res.response.expires_in));
                            store.commit("saveTokenExpire", expiredate);

                            error.config.__isRetryRequest = true;
                            error.config.headers.Authorization = 'Bearer ' + res.response.token;
                            return axios(error.config);
                        } else {
                            // 刷新token失败 清除token信息并跳转到登录页面
                            ToLogin()
                        }
                    });
                } else {
                    // 返回 401，并且不知用户操作活跃期内 清除token信息并跳转到登录页面
                    ToLogin()
                }

            }
            else if (error.response.status == 500) {
                Vue.prototype.$message({
                    message: '500 Internal Server Error，请联系管理员！',
                    type: 'error'
                });
                endLoading();
            }
            else
            {
                Vue.prototype.$message({
                    message: error.response.statusText,
                    type: 'error'
                });
                endLoading();
            }
        }
        return ""; // 返回接口返回的错误信息
    }
);



//微信扫描登陆
export const getQrCodeUri = params => {
    return axios.get(`${base}/WebSite/GetQrCodeUri`, params);
};
//获取accerss_token和openid
export const getWxToken = params => {
    return axios.get(`${base}/WebSite/GetAccessToken`, params);
};
//获取微信用户信息
export const getWxUserInfo = params => {
    return axios.get(`${base}/WebSite/GetUserInfo`, params);
};

//获取本地用户信息
export const getUserInfoByUnionId = params => {
    return axios.get(`${base}/User/GetUserInfoByUnionId`, params);
};

// 登录(1.登陆后session中保存token，tokenExp，userid信息。2.刷新后，重新请求token，tokenExp)
export const getToken = params => {
    return axios.get(`${base}/identity/token`, params);
};
//获取公司岗亭列表
export const getDoorList = params => {
    return axios.get(`${base}/CompanyDoor/GetDoorList`, params);
};

//用户管理
export const getUserInfoById = params => {
    return axios.get(`${base}/User/GetUserInfoById`, params);
};

//获取用户角色集合
export const getUserRoleList = params => {
    return axios.get(`${base}/UserRole/GetUserRoleList`, params);
};



// 登录
export const requestLogin = params => {
    return axios.get(`${base}/api/login/jwttoken3.0`, { params: params }).then(res => res.data);
};

export const refreshToken = params => {
    return axios.get(`${base}/api/login/RefreshToken`, { params: params }).then(res => res.data);
};

export const saveRefreshtime = params => {

    let nowtime = new Date();
    let lastRefreshtime = window.localStorage.refreshtime ? new Date(window.localStorage.refreshtime) : new Date(-1);
    let expiretime = new Date(Date.parse(window.localStorage.TokenExpire))

    let refreshCount = 1;//滑动系数
    if (lastRefreshtime >= nowtime) {
        lastRefreshtime = nowtime > expiretime ? nowtime : expiretime;
        lastRefreshtime.setMinutes(lastRefreshtime.getMinutes() + refreshCount);
        window.localStorage.refreshtime = lastRefreshtime;
    } else {
        window.localStorage.refreshtime = new Date(-1);
    }
};
const ToLogin = params => {
    store.commit("saveToken", "");
    store.commit("saveTokenExpire", "");
    store.commit("saveTagsData", "");
    window.localStorage.removeItem('user');
    window.localStorage.removeItem('wxUser');
    window.localStorage.removeItem('NavigationBar');
      router.replace({
            path: "/login",
            query: { redirect: router.currentRoute.fullPath }
        });

        window.location.reload()
    
};
//登陆异常
export const loginError = params => {
    store.commit("saveToken", "");
    store.commit("saveTokenExpire", "");
    store.commit("saveTagsData", "");
    window.localStorage.removeItem('user');
    window.localStorage.removeItem('wxUser');
    window.localStorage.removeItem('NavigationBar');
};

export const getUserByToken = params => {
    return axios.get(`${base}/api/user/getInfoByToken`, { params: params }).then(res => res.data);
};

export const toLogin = params => {
    ToLogin();
};


//知识点(Knowledge)
export const getKnowTreeData = params => {
    return axios.get(`${base}/KnowledgePoint/kptree`, params);
};
export const getKnowListData = params => {
    return axios.get(`${base}/KnowledgePoint/lft`, params);
};
export const postKnowModelMothod = params => {
    return axios.post(`${base}/KnowledgePoint/submit`, params);
};
export const delKnowModelMothod = params => {
    return axios.post(`${base}/KnowledgePoint/kpd`, params);
};

export const getKnowModelPareItemsMothod = params => { //获取父节点集合
    return axios.get(`${base}/KnowledgePoint/nckps`, params);
};

//考试(examination)
export const getCityInfo = params => {
    return axios.get(`${base}/Examination/cityInfo`, params);
};
export const getExamListMothod = params => {
    return axios.get(`${base}/Examination/List`, params);
};
export const getExamModelMothod = params => {
    return axios.get(`${base}/Examination/GetModel`, params);
};
export const postExamModelMothod = params => {
    return axios.post(`${base}/Examination/Post`, params);
};
export const delExamModelMothod = params => {
    return axios.post(`${base}/Examination/Delete`, params);
};
export const updateExamModelMothod = params => {
    return axios.patch(`${base}/Examination/Patch`, params);
};
export const uploadExamListMothod = params => {
    return axios.post(`${base}/Examination/Upload`, params);
};

//试题知识点(questionKnowledge)
export const addQuestKnowledges = params => {
    //参数格式：data:{id:id,value[1,2,3,4]}，id是试题主键value是知识点主键集合
    //实现功能：1.删除questionKnowledge表中试题id记录。2.新增试题id对应的知识点value集合记录。
    return axios.post(`${base}/QuestionKnowledge/post`, params);
};

//试题(Question)
export const editQuestion = params => {
    //参数：data试题Question表对象。
    //实现功能：1.修改Question表。
    return axios.put(`${base}/Question/put`, params);
};

//获取试题树形结构(Question)
export const getParentQueTree = params => {
    //参数：params{id:id} //id为题目id
    //实现功能：树形结构查询出来，把传送的id的题目过滤
    return axios.get(`${base}/Question/getQueTree`, params);
};

//webSocket测试
export const ws = params => {
    //参数格式：data:{id:id,value[1,2,3,4]}，id是试题主键value是知识点主键集合
    //实现功能：1.删除questionKnowledge表中试题id记录。2.新增试题id对应的知识点value集合记录。
    return axios.get(`${base}/Reservation/ws`, params);
};

// 公司审核管理
export const getCompanyListData = params => {
    //return data;
    return axios.get(`${base}/Company/GetCompanyList`, params);
};

//登记
export const getToDayGuardReservationList = params => {
    return axios.get(`${base}/Reservation/GetToDayGuardReservationList`, params);
};

export const getReservationRecord = params => {
    return axios.get(`${base}/Reservation/GetReservationRecordByState`, params);
};

export const getReservationRecords = params => {
    return axios.get(`${base}/Reservation/getReservationRecords`, params);
};


export const getReservationUserDto = params => {
    return axios.get(`${base}/Reservation/GetReservationUserDto`, params);
};

export const getReservationCompanies = params => {
    return axios.get(`${base}/Reservation/GetReservationCompanies`, params);
};

export const saveAccessInfo = params => {
    return axios.post(`${base}/Reservation/SaveAccessInfo`, params);
};

export const saveLeaveInfo = params => {
    return axios.post(`${base}/Reservation/SaveLeaveInfo`, params);
};

export const getReservationListByCondition = params => {
    return axios.get(`${base}/Reservation/GetReservationListByCondition`, params);
};

export const getCompaniesInfo = params => {
    return axios.get(`${base}/ReservationCompanies/GetCompaniesInfo`, params);
};

export const userAuthentication = params => {
    return axios.post(`${base}/User/UserAuthentication`, params);
};
//通过身份证和姓名查询所有今日预约单
export const getAllDataByCard = params => {
    return axios.get(`${base}/ReservationCompanies/GetCompaniesInfo`, params);
};
//根据人员姓名和身份证号码获取预约单记录
export const getToDayReservationList = params => {
    return axios.get(`${base}/Reservation/GetToDayReservationList`, params);
};
//预约ID查询预约信息
export const GetReservationDtoById = params => {
    return axios.get(`${base}/Reservation/GetReservationDtoById`, params);
};
//预约ID和人员Id查询预约的人员信息（人员Id可以是随从人员Id）
export const GetReservationUserDtoById = params => {
    return axios.get(`${base}/Reservation/GetReservationUserDtoById`, params);
};
//预约人员部分准入操作
export const saveTargetUserAccessInfo = params => {
    return axios.post(`${base}/Reservation/SaveTargetUserAccessInfo`, params);
};
//随行人员部分准入操作
export const saveEntourageUserAccessInfo = params => {
    return axios.post(`${base}/Reservation/SaveEntourageUserAccessInfo`, params);
};
//预约人员部分准入操作
export const saveTargetUserLeaveInfo = params => {
    return axios.post(`${base}/Reservation/SaveTargetUserLeaveInfo`, params);
};
//随行人员部分准入操作
export const saveEntourageUserLeaveInfo = params => {
    return axios.post(`${base}/Reservation/saveEntourageUserLeaveInfo`, params);
};
//获取个人身份证信息
export const getUserProfileInfoById = params => {
    return axios.get(`${base}/User/GetUserProfileInfoById`, params);
};

//黑白名单管理
export const getCompanyVisitorList = params => {
    return axios.get(`${base}/CompanyVisitorList/GetCompanyVisitorList`, params);
};
export const isExistUserInfo = params => {
    return axios.get(`${base}/CompanyVisitorList/isExistUserInfo`, params);
};
export const delVisitorList = params => {
    return axios.get(`${base}/CompanyVisitorList/DelVisitorList`, params);
};
export const addVisitorType = params => {
    return axios.post(`${base}/CompanyVisitorList/AddVisitorType`, params);
};
export const isExistVisitorInfo = params => {
    return axios.get(`${base}/CompanyVisitorList/isExistVisitorInfo`, params);
};


//内部通讯录
//部门
export const getNbtxlDeptListData = params => {

    return axios.get(`${base}/CompanyDepartment/GetDepartmentListById`, params);
};
export const addNbtxlDeptModelMothod = params => {
    return axios.post(`${base}/CompanyDepartment/AddDepartment`, params);
};
export const updateNbtxlDeptModelMothod = params => {
    return axios.post(`${base}/CompanyDepartment/UpdDepartmentInfo`, params);
};
export const hbNbtxlDeptModelMothod = params => {
    return axios.post(`${base}/CompanyDepartment/MergeDepartmentInfo`, params);
};

export const delNbtxlDeptModelMothod = params => {
    return axios.get(`${base}/CompanyDepartment/DelDepartmentInfo`, params);
};

//门卫
export const getNbtxlGuardListData = params => {
    return axios.get(`${base}/User/GetGuardList`, params);
};
export const postNbtxlGuardModelMothod = params => {
    //return axios.post(`${base}/KnowledgePoint/submit`, params);
};
export const delNbtxlGuardModelMothod = params => {
    return axios.post(`${base}/User/DelUserInfoById`, params);
};

//员工
export const getNbtxlWorksListData = params => {

    return axios.get(`${base}/CompanyDepartment/GetDepartmentAndUserList`, params);
};
export const postNbtxlWorksModelMothod = params => {
    //return axios.post(`${base}/KnowledgePoint/submit`, params);
};
export const delNbtxlWorksModelMothod = params => {
    return axios.post(`${base}/User/DelUserInfoById`, params);
};

export const updateCompanyState = params => {
    //参数格式：data:{id:id,value[1,2,3,4]}，id是试题主键value是知识点主键集合
    //实现功能：1.删除questionKnowledge表中试题id记录。2.新增试题id对应的知识点value集合记录。
    return axios.post(`${base}/Company/UpdCompanyInfo`, params);
};

//来访统计
export const getVisitorListCount = params => {
    return axios.get(`${base}/Statistics/GetVisitorListCount`, params);
};

export function getNavigationBars(role){
    const jsonStr = {"status": 200,"success": true,"msg": "获取成功",
        "response": {"name": "根节点", "IsHide": false,"IsButton": false, "path": "","Func": null,"iconCls": "",
            "meta": {
                "title": null,
                "requireAuth": true,
                "NoTabPage": false,
                "keepAlive": false
            },
            "children": []
        }
    }
    
    if(role==='admin')
    {
        jsonStr.response.children.push({
                   
            "name": "其它管理",
            "IsHide": false,
            "IsButton": false,
            "path": "/fksys/otherMgr",
            "Func": null,
            "iconCls": "el-icon-school",
            "meta": {
                "title": "其它管理",
                "requireAuth": true,
                "NoTabPage": false,
                "keepAlive": false
            },
            "children": null
        });
    }
    else if(role==='guard')
    {
        jsonStr.response.children.push({
                   
            "name": "登记",
            "IsHide": false,
            "IsButton": false,
            "path": "/fksys/index",
            "Func": null,
            "iconCls": "el-icon-monitor",
            "meta": {
                "title": "登记",
                "requireAuth": true,
                "NoTabPage": false,
                "keepAlive": false
            },
            "children": null
        });
        jsonStr.response.children.push({
                   
            "name": "公司审核",
            "IsHide": false,
            "IsButton": false,
            "path": "/fksys/checkCompany",
            "Func": null,
            "iconCls": "el-icon-box",
            "meta": {
                "title": "公司审核",
                "requireAuth": true,
                "NoTabPage": false,
                "keepAlive": false
            },
            "children": null
        });
    }
    else if(role==='dtsc')
    {
        jsonStr.response.children.push({
                   
            "name": "公司审核",
            "IsHide": false,
            "IsButton": false,
            "path": "/fksys/checkCompany",
            "Func": null,
            "iconCls": "el-icon-box",
            "meta": {
                "title": "公司审核",
                "requireAuth": true,
                "NoTabPage": false,
                "keepAlive": false
            },
            "children": null
        });
        
    }
    return jsonStr;
}

export const getNavigationBar = params => {
   
    //return axios.get(`${base}/api/permission/GetNavigationBar`, { params: params }).then(res => res.data);
};







// WEBPACK FOOTER //
// ./src/api/api.js